import fetch from '../fetch';
import { errorMessages } from '../../constants';
import { FULFILLMENTS_DEACTIVATE } from '../../constants/endpoints';

export const DEACTIVATE_FULFILLMENT = 'DEACTIVATE_FULFILLMENT';
export const FULFILLMENT_DEACTIVATED = 'FULFILLMENT_DEACTIVATED';
export const DEACTIVATE_FULFILLMENT_FAILED = 'DEACTIVATE_FULFILLMENT_FAILED';

const deactivateFulfillmentAction = cancellationType => async dispatch => {
  dispatch({ type: DEACTIVATE_FULFILLMENT });

  try {
    const endpoint = cancellationType
      ? `${FULFILLMENTS_DEACTIVATE}?cancellationType=${encodeURIComponent(cancellationType)}`
      : FULFILLMENTS_DEACTIVATE;

    const requestBody = {
      method: 'DELETE',
    };

    const result = await dispatch(fetch(endpoint, requestBody));

    // DELETE may return 204 No Content (result is null) — treat as success
    const payload = result?.data ?? result ?? null;

    dispatch({
      type: FULFILLMENT_DEACTIVATED,
      payload,
    });

    return payload;
  } catch (error) {
    const errorMessage = {
      heading: errorMessages.someDataMissing,
      messages: [errorMessages.technicalIssues],
    };

    dispatch({
      type: DEACTIVATE_FULFILLMENT_FAILED,
      error: true,
      payload: new Error(JSON.stringify(errorMessage)),
    });

    throw error;
  }
};

export default deactivateFulfillmentAction;
